import React from 'react';
import IconoAliado from '../../../../icons/tienda.png';
import flecha from '../../../../icons/Flechaliado.png';
import '../../styles/coberturaNacional/TarjetaAliado.css';

const TarjetaAliado = ({ onFlechaClick }) => {
  return (
    <div className="header-aliado">
      <img
        src={IconoAliado}
        loading="lazy"
        alt="Icono tienda"
        className="icono-aliado"
      />
      <h3 className="titulo-aliado">
        Aliados <br />
        comerciales
      </h3>
      <img
        src={flecha}
        alt="Icono flecha"
        loading="lazy"
        className="icono-aliado-flecha"
        onClick={onFlechaClick}
        style={{ cursor: 'pointer' }}
      />
    </div>
  );
};

// Exportación memorizada para evitar renders innecesarios
export default React.memo(TarjetaAliado);
